import React, {useEffect, useState} from 'react';
import {injectIntl} from 'react-intl';
import axios from 'axios';
import {useLocation} from 'react-router';
import AccordionWrapper from '@Components/AccordionWrapper';
import PageHeader from '@Components/PageHeader';
import Block from '@Components/Block';
import {List} from 'react-content-loader';
import {Helmet} from 'rnd-helmet';

const Search = ({intl, staticContext, match}) => {
  let initialData = {};
  if (staticContext && staticContext.data) {
    initialData = staticContext.data;
  } else if (typeof window !== 'undefined' && window.__ROUTE_DATA__) {
    initialData = window.__ROUTE_DATA__;
    delete window.__ROUTE_DATA__;
  }
  const [state, setState] = useState(initialData);
  const location = useLocation();
  const canonicalURL = `${process.env.REACT_APP_BASE_URL}${location.pathname}`;

  useEffect(() => {
    if (Object.keys(state).length === 0) {
      axios.post(`${process.env.REACT_APP_API_PREFIX}/get-callback`, {
        callback: '@Callbacks/getSalaryData',
        currentRoute: {...match, ...{routeName: 'search'}},
        data: {},
      }).then((response) => {
        setState(response.data);
      });
    }
  }, []);

  if (Object.getPrototypeOf(state) === Object.prototype && !Object.keys(state).length) {
    return (
      <>
        <List />
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({id: 'TalentSalary.Page.Meta.Title'}, {
            sitename: process.env.REACT_APP_SITENAME,
          })}
        </title>
        <link rel="canonical" href={canonicalURL} />
        <meta name="description" content={intl.formatMessage({id: 'TalentSalary.Page.Meta.Description'})} />
      </Helmet>
      <PageHeader title={intl.formatMessage({id: 'TalentSalary.Page.Title'})} />
      <Block title="Salary.Page.Title" blockSmall={true}>
        <AccordionWrapper state={state.results} />
      </Block>
    </>
  );
};

export default injectIntl(Search);
